import { ProFormColumnsType } from '@ant-design/pro-components';
import { BaseFormSchemaWithJsxMessagesProps } from '../types';

type SubmitDipFormSchemaProps = BaseFormSchemaWithJsxMessagesProps;

export const submitDipFormSchema = (props: SubmitDipFormSchemaProps): ProFormColumnsType[] => [
  {
    renderFormItem: () => (
      <h4 className={'mb-0'}>{props.formatMessage({ id: 'btlApplicationForm.SUBMIT_DIP.form.header' })}</h4>
    ),
  },
  {
    dataIndex: 'checkboxes',
    valueType: 'checkbox',
    className: 'mb-4',
    fieldProps: {
      className: 'flex flex-col gap-3 [&_.ant-checkbox-wrapper]:items-start [&_.ant-checkbox-wrapper]:!ml-0',
      options: [
        {
          label: props.formatMessage({ id: 'btlApplicationForm.SUBMIT_DIP.creditConsentAccepted.label' }),
          value: 'creditConsentAccepted',
        },
        {
          label: props.formatMessage(
            { id: 'btlApplicationForm.SUBMIT_DIP.privacyAccepted.label' },
            {
              privacyPolicyLink: (str: string) => (
                <a
                  target='_blank'
                  href='https://www.strideup.co/privacy-policy'
                  rel='noreferrer'
                  onClick={e => e.stopPropagation()}
                >
                  {str}
                </a>
              ),
            },
          ),
          value: 'privacyAccepted',
        },
      ],
    },
    formItemProps: {
      className: '[&_.ant-form-item-control-input]:overflow-visible [&_.ant-form-item-control-input]:mb-2',
      validateTrigger: 'onSubmit',
      rules: [
        {
          validator: (_, value) => {
            const allValues = ['creditConsentAccepted', 'privacyAccepted'];
            return allValues.every(v => value?.includes(v))
              ? Promise.resolve()
              : Promise.reject(
                  new Error(
                    props.formatMessage({
                      id: 'btlApplicationForm.SUBMIT_DIP.allTermsRequired.label',
                    }),
                  ),
                );
          },
        },
      ],
    },
  },
  // The notes section will only be displayed when the Broker is able to submit a DIP or the application
  // This is because we add this text to the Case Notes in the model and it's difficult to re-hydrate
  // a specific note to display here.
  {
    hideInForm: !props.isFormEditable,
    renderFormItem: () => (
      <div className={'-mb-6'}>
        <h2 className={'-mb-4'}>{props.formatMessage({ id: 'btlApplicationForm.SUBMIT_DIP.notes.header' })}</h2>
        <p>{props.formatMessage({ id: 'btlApplicationForm.SUBMIT_DIP.notes.message' })}</p>
      </div>
    ),
  },
  {
    hideInForm: !props.isFormEditable,
    dataIndex: 'notes',
    valueType: 'textarea',
    fieldProps: {
      autoSize: {
        minRows: 6,
        maxRows: 30,
      },
    },
  },
];
